import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector, useDispatch } from 'react-redux';
import {
  setClaimStatus,
  setInstallerEmail,
} from '../../features/installer/installerJourneySlice';
import {
  getInstallerDetails,
  setSubcontractorId,
  setSubcontractorCompanyName,
  setSubcontractorEmail,
  setSubcontractorFirstName,
  setSubcontractorLastName,
} from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const ConfirmSubContractor = ({ location }) => {
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;
  const history = useHistory();
  const dispatch = useDispatch();
  const subcontractorDetailsRedux = useSelector(getInstallerDetails);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.ConfirmSubcontractor.s6',
    'Confirm subcontractor details - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  dispatch(
    setSubcontractorId(
      subcontractorDetailsRedux.subcontractorData.installer_number
    )
  );
  dispatch(
    setSubcontractorCompanyName(
      subcontractorDetailsRedux.subcontractorData.company_name
    )
  );
  dispatch(
    setSubcontractorEmail(subcontractorDetailsRedux.subcontractorData.email)
  );
  dispatch(
    setSubcontractorFirstName(
      subcontractorDetailsRedux.subcontractorData.primary_contact_firstname
    )
  );
  dispatch(
    setSubcontractorLastName(
      subcontractorDetailsRedux.subcontractorData.primary_contact_lastname
    )
  );

  const handleButton = () => {
    dispatch(setClaimStatus('INSTALLER_CLAIM_INCOMPLETE'));
    dispatch(
      setInstallerEmail(subcontractorDetailsRedux.subcontractorData.email)
    );
    // dispatch(setSubcontractorId(subcontractorDetailsRedux.installer_number));
    // eslint-disable-next-line
    isFromCheckAnswers && history.push('/installer/installation-date');
  };

  const pageModel = (
    <div>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.ConfirmSubcontractor.s1',
          'Confirm subcontractor details'
        )}
      </h1>
      <dl className="govuk-summary-list govuk-!-margin-bottom-9">
        <div className="govuk-summary-list__row">
          <dt className="govuk-summary-list__key">
            {copyProvider.getCopy(
              'installer.ConfirmSubcontractor.s2',
              'Subcontractor name'
            )}
          </dt>
          <dd className="govuk-summary-list__value" data-test="installer-name">
            {subcontractorDetailsRedux.subcontractorData.company_name}
          </dd>
        </div>

        <div className="govuk-summary-list__row">
          <dt className="govuk-summary-list__key">
            {copyProvider.getCopy(
              'installer.ConfirmSubcontractor.s3',
              'Subcontractor OZEV installer number'
            )}
          </dt>
          <dd
            className="govuk-summary-list__value"
            data-test="installer-number"
          >
            {subcontractorDetailsRedux.subcontractorData.installer_number}
          </dd>
        </div>
      </dl>

      <p>
        <Link
          to="/installer/subcontractor"
          className="govuk-link govuk-body govuk-!-font-size-19"
        >
          {copyProvider.getCopy(
            'installer.ConfirmSubcontractor.s4',
            'This is not my subcontractor'
          )}
        </Link>
      </p>
      <br />
      <div className="govuk-button-group">
        <Button className="govuk-button" onClick={handleButton}>
          {copyProvider.getCopy(
            'installer.ConfirmSubcontractor.s5',
            'Confirm and continue'
          )}
        </Button>
      </div>
    </div>
  );
  return pageModel;
};
ConfirmSubContractor.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

ConfirmSubContractor.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};
export default ConfirmSubContractor;
